export default {"src":"/_next/static/media/0x527ec46ac094b399265d1d71eff7b31700aa655d.72a6a96a.svg","height":26,"width":26,"blurWidth":0,"blurHeight":0};